/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo } from 'react'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  deleteDayAheadAward,
  saveDayAheadAward,
  retrieveDayAheadAward,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
  isValidYearRange,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber } from 'antd'
// import { ErrorContext } from 'context'
import * as Actions from 'core/EventActions'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'

import CommonScreen from 'admin/component/CommonScreen'

// import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { PNodeZoneContext } from 'context'

const title = 'Day Ahead Award'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'transdate',
    display: 'Trans Date',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'hour1',
    display: 'Hour 1',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'hour2',
    display: 'Hour 2',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour3',
    display: 'Hour 3',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour4',
    display: 'Hour 4',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour5',
    display: 'Hour 5',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour6',
    display: 'Hour 6',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour7',
    display: 'Hour 7',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour8',
    display: 'Hour 8',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour9',
    display: 'Hour 9',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour10',
    display: 'Hour 10',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour11',
    display: 'Hour 11',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour12',
    display: 'Hour 12',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour13',
    display: 'Hour 13',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour14',
    display: 'Hour 14',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour15',
    display: 'Hour 15',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour16',
    display: 'Hour 16',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour17',
    display: 'Hour 17',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour18',
    display: 'Hour 18',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour19',
    display: 'Hour 19',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour20',
    display: 'Hour 20',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour21',
    display: 'Hour 21',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour22',
    display: 'Hour 22',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour23',
    display: 'Hour 23',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour24',
    display: 'Hour 24',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),

  numCol({
    ident: 'hour25',
    display: 'Hour 25',
    isFiltered: true,
    displayFormat: '0.000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

// eslint-disable-next-line no-unused-vars
const DayAheadAward = ({ targetInfo, envConfig, actionPermits, ...props }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)
  // const { setError } = useContext(ErrorContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    MarginAnalysisContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow
      style={{ padding: '10px 15px', overflowX: 'hidden', overflowY: 'auto' }}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '60px 80px 80px 80px 80px 80px 80px 80px 80px 80px 80px 80px 80px 80px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 5' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3={false}
          />
        </div>
        <Label>Trans Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.transdateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              transdate: date.format('YYYY-MM-DD'),
              transdateObj: date,
            })
          }}
          style={{ width: '100%', gridColumnEnd: 'span 3' }}
        />
        <Label>Hour 1:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour1}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour1: value })}
        />
        <Label>Hour 2:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour2}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour2: value })}
        />
        <Label>Hour 3:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour3}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour3: value })}
        />
        <Label>Hour 4:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour4}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour4: value })}
        />
        <Label>Hour 5:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour5}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour5: value })}
        />
        <Label>Hour 6:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour6}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour6: value })}
        />
        <Label>Hour 7:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour7}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour7: value })}
        />
        <Label>Hour 8:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour8}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour8: value })}
        />
        <Label>Hour 9:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour9}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour9: value })}
        />
        <Label>Hour 10:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour10}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour10: value })}
        />
        <Label>Hour 11:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour11}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour11: value })}
        />
        <Label>Hour 12:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour12}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour12: value })}
        />
        <Label>Hour 13:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour13}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour13: value })}
        />
        <Label>Hour 14:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour14}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour14: value })}
        />
        <Label>Hour 15:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour15}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour15: value })}
        />
        <Label>Hour 16:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour16}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour16: value })}
        />
        <Label>Hour 17:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour17}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour17: value })}
        />
        <Label>Hour 18:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour18}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour18: value })}
        />
        <Label>Hour 19:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour19}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour19: value })}
        />
        <Label>Hour 20:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour20}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour20: value })}
        />
        <Label>Hour 21:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour21}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour21: value })}
        />
        <Label>Hour 22:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour22}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour22: value })}
        />
        <Label>Hour 23:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour23}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour23: value })}
        />
        <Label>Hour 24:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour24}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour24: value })}
        />
        <Label>Hour 25:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hour25}
          defaultValue={0}
          onChange={value => setInsertData({ ...insertData, hour25: value })}
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>
        <div style={{ gridColumnEnd: 'span 2', display: 'grid' }}>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
        </div>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </CriteriaRow>
  )

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const withCriteria = (state, props, selectedUnits) => {
    return {
      start: selectedDateRangePicker[0].format('YYYY-MM-DD'),
      end: selectedDateRangePicker[1].format('YYYY-MM-DD'),
      units: (selectedUnits || [])
        .filter(e => !!e)
        .map(e => unitIdEmktIdMap[e.unitId]),
    }
  }

  const screenCriteria = (s, p, u, onCriteriaChnage) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '0px', minWidth: '200px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onCriteriaChnage()
          // retrieve({ dates: d })
        }}
      />
    )
  }

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }
  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }
  return (
    <div>
      <CommonScreen
        beforeRetrieveValidation={beforeRetrieveValidation}
        // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
        withoutModify={!writeEventActionPermission}
        withDelete={!writeEventActionPermission}
        allowInsert={writeEventActionPermission}
        isEditableGrid={isEditableGrid}
        extraUnitSelectionProps={extraUnitSelectionProps}
        withUnitSelection
        withDatePickerTitle="Date:"
        autoRetrieve={false}
        isAdminScreen={false}
        withCriteria={withCriteria}
        withDatePicker={false}
        screenCriteria={screenCriteria}
        title={title}
        titleProps={{ minWidth: '155px' }}
        header={headerWithFormatter}
        saveTask={saveDayAheadAward}
        retrieveTask={retrieveDayAheadAward}
        deleteTask={deleteDayAheadAward}
        altBy={u => u.unitId}
        widthOffset={50}
        insertComp={insertEvent && insertComp}
        insertCompHeight={120}
        onInsertEvent={b => setInsertEvent(b)}
        sortOptions={headers}
        initialSortOptions={headers}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
})

export default connect(mapStateToProps)(DayAheadAward)
